import type React from 'react';

import {
    Dialog,
    DialogBody,
    DialogBrandedLayout,
    DialogHeader,
    Heading,
} from '@gitbook/spine-react';

import { useSiteContext } from '../../../../../state';
import { PublishBody } from './contents/PublishBody';
import { PublishFooter } from './contents/PublishFooter';

export function PublishDialog(): React.ReactElement {
    const { site } = useSiteContext();

    return (
        <Dialog size="auto">
            <DialogBrandedLayout>
                <DialogHeader>
                    <div className="flex items-center gap-2">
                        <Heading>{site.title} is ready to go live!</Heading>
                    </div>
                </DialogHeader>

                <DialogBody className="mt-4">
                    <PublishBody />
                </DialogBody>

                <PublishFooter />
            </DialogBrandedLayout>
        </Dialog>
    );
}
